// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import * as React from 'react';
import classNames from '@ta/common.classnames';

import base from './SingleElementAnimation.less';
import styles from './FeedSectionItemLoadingSkeleton.less';

// Create a single element skeleton loader.
const FeedSectionItemLoadingSkeleton = () => (
  <div className={classNames(base.animation, styles.feedSectionItem)} />
);

export default FeedSectionItemLoadingSkeleton;
